import { List } from '@radix-ui/react-navigation-menu'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export const NavigationMenuList = forwardRef<
  ElementRef<typeof List>,
  ComponentPropsWithoutRef<typeof List>
>(({ className, ...props }, ref) => (
  <List
    ref={ref}
    className={cn(
      'group flex flex-1 list-none items-center justify-center text-sm',
      className
    )}
    {...props}
  />
))
NavigationMenuList.displayName = List.displayName
